<h4>{{pageData.details.name}}</h4>

<img [src]="'/files/rollershuttermontage/' + pageData.details.image" [alt]="pageData.details.name">

<div [innerHTML]="pageData.details.description"></div>
